var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { styles } from './styles';
import { SelectButton, useDropdown } from "../../../controls";
import { DotsIcon } from './DotsIcon';
import { ToggleMenu, ToggleMenuItem } from "../../../helpers/ToggleMenu";
export function GridColumnMenu(props) {
    var element = useDropdown({
        renderControl: function (props) {
            return (React.createElement(SelectButton, __assign({}, props.button, { active: props.isActive, iconBefore: React.createElement(DotsIcon, { className: styles.icon }), iconAfter: null, placeholder: null })));
        },
        renderPopover: function (_a) {
            var popover = _a.popover;
            return (React.createElement(ToggleMenu, __assign({}, popover), props.items.map(function (i) { return (React.createElement(ToggleMenuItem, { key: i.id, title: i.title, isChecked: i.value, onChange: i.onClick })); })));
        }
    })[0];
    return React.createElement("div", { className: styles.menu }, element);
}
//# sourceMappingURL=GridColumnMenu.js.map